module.exports = __webpack_public_path__ + "img/trash-white.f0f0f331.svg";